//import React from "react";
import React, { memo, useEffect } from "react";

const Item = memo(({ user, handleDelete }) => {

    useEffect(() => {
        //console.log("Item Render" + user.name)
    })

    return (
        <li>
        <div className="iotGrid-item">
            {/* { user.name } */}
            Id: {user.id} 
            <br></br>
            {/* name: { user.name } */}
            topic: { user.topic }
            <br></br>
            messageeee: { user.message }
            {/* {JSON.stringify(user)} ---- */}
            <button onClick={() => handleDelete(user.id)}>
                Delete ...
            </button>
            </div>
        </li>
    )
})

export default Item